import React, {useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {Button, Card, Col, ListGroup, ProgressBar, Row} from 'react-bootstrap'
import {DateTime} from 'luxon'
import Moment from 'react-moment'
import Message from './Message'
import MainContainer from './MainContainer'
import Loader from './Loader'
import {continueQuiz, listUserAnswers, startNewQuiz} from '../actions/answerActions'

const UserDashboard = ({history}) => {
    const dispatch = useDispatch()
    const now = DateTime.now().setZone('America/Sao_Paulo')
    const cutoff = DateTime.fromISO('2025-05-14T23:59:59', {
        zone: 'America/Sao_Paulo'
    })

    const enableResponses = process.env.REACT_APP_DISABLE_CUTOFF_DATE || now < cutoff

    const {loading, error, answers} = useSelector((state) => state.answerList)
    const userAnswer = useSelector((state) => state.userAnswer)
    useEffect(() => {
        dispatch(listUserAnswers())
    }, [dispatch])

    const handleContinueClick = (e, answerId) => {
        if (!enableResponses) {
            alert('Você não pode continuar um teste após as 23:59')
            return
        }

        if (userAnswer.answer.id !== answerId) {
            dispatch(continueQuiz(answerId))
        }
        history.push('/quiz')
    }

    const handleNewQuiz = () => {
        if (!enableResponses) {
            alert('Você não pode iniciar um novo teste após as 23:59')
            return
        }

        dispatch(startNewQuiz())
        history.push('/quiz')
    }

    return (
        <MainContainer>
            <Row>
                <Col>
                    <h1>Dashboard</h1>
                </Col>
                {answers.length === 0 && enableResponses && (
                    <Col className="align-self-center text-right">
                        <Button
                            type="button"
                            onClick={handleNewQuiz}
                            title="Clique e descubra o seu potencial"
                            style={{fontSize: '0.9rem', padding: '3px 6px'}}
                            className="btn btn-outline-primary text-white"
                        >
                            <i className="fas fa-plus"></i>
                        </Button>
                    </Col>
                )}
            </Row>
            {answers.length === 0 && (
                <Message>Você ainda não possui nenhum avaliação</Message>
            )}
            {error && <Message variant="danger">{error}</Message>}
            {loading ? (
                <Loader/>
            ) : (
                <Row>
                    {answers.map((answer) => {
                        if (userAnswer.answer.id === answer.id) {
                            answer = userAnswer.answer
                        }
                        return (
                            <Col xs={12} md={6} key={answer.id} className="my-3">
                                <Card border="primary" bg="primary" style={{width: '100%'}}>
                                    <Card.Header style={{color: 'white'}}>
                                        Avaliação
                                    </Card.Header>
                                    <ListGroup variant="flush">
                                        <ListGroup.Item>
                                            <strong>Iniciado em:</strong>{' '}
                                            {<Moment format="DD/MM/YY">{answer.createdAt}</Moment>}
                                        </ListGroup.Item>
                                        <ListGroup.Item>
                                            <strong>Progresso:</strong>{' '}
                                            {
                                                <ProgressBar
                                                    max={answer.number_of_questions}
                                                    now={answer.last_answered_question}
                                                />
                                            }
                                        </ListGroup.Item>
                                        <ListGroup.Item>
                                            {answer.completed ? (
                                                <Row>
                                                    <Col className="text-left">
                                                        <p className="text-secondary">
                                                            Você receberá o resultado do seu teste no primeiro
                                                            encontro.
                                                        </p>
                                                    </Col>
                                                </Row>
                                            ) : (
                                                enableResponses && (
                                                    <Button
                                                        type="button"
                                                        variant="success"
                                                        onClick={(e) => handleContinueClick(e, answer.id)}
                                                    >
                                                        Continuar
                                                    </Button>
                                                )
                                            )}
                                        </ListGroup.Item>
                                    </ListGroup>
                                </Card>
                            </Col>
                        )
                    })}
                </Row>
            )}
            {answers.length === 0 && enableResponses && (
                <Row className="mt-5">
                    <Col className="text-right">
                        <Button
                            type="button"
                            onClick={handleNewQuiz}
                            className="btn btn-outline-primary w-100 text-white"
                        >
                            Clique e descubra o seu potencial.
                        </Button>
                    </Col>
                </Row>
            )}
        </MainContainer>
    )
}

export default UserDashboard
